import { lazy, Suspense } from 'react'
import { Shell } from './components/shell'
import { Skeleton } from './components/ui'
import { useAuth } from './lib/auth'
import { AlertProvider } from './lib/alerts'
import { usePathname } from './lib/route'
import { StreamProvider } from './lib/stream'
import { LoginPage } from './pages/login'
import { LivePage } from './pages/live'

const SourcesPage = lazy(() => import('./pages/sources').then((module) => ({ default: module.SourcesPage })))
const SystemPage = lazy(() => import('./pages/system').then((module) => ({ default: module.SystemPage })))
const AdminPage = lazy(() => import('./pages/admin').then((module) => ({ default: module.AdminPage })))
const EventsPage = lazy(() => import('./pages/intelligence').then((module) => ({ default: module.EventsPage })))
const EventDetailPage = lazy(() => import('./pages/event-detail').then((module) => ({ default: module.EventDetailPage })))
const StoriesPage = lazy(() => import('./pages/intelligence').then((module) => ({ default: module.StoriesPage })))
const IndexingPage = lazy(() => import('./pages/intelligence').then((module) => ({ default: module.IndexingPage })))
const TelegramPage = lazy(() => import('./pages/telegram').then((module) => ({ default: module.TelegramPage })))

export function App() {
  const { user, loading } = useAuth()
  const pathname = usePathname()
  if (loading) return <div className="app-loading" aria-label="Loading Blaze"><span className="app-loading__mark">B</span><Skeleton /></div>
  if (!user) return <LoginPage />
  const page = route(pathname, user.role)
  return <StreamProvider enabled><AlertProvider><Shell><Suspense fallback={<PageFallback />}>{page}</Suspense></Shell></AlertProvider></StreamProvider>
}

function route(pathname: string, role: string) {
  if (pathname.startsWith('/sources')) return <SourcesPage />
  if (pathname.startsWith('/events/')) return <EventDetailPage />
  if (pathname.startsWith('/events')) return <EventsPage />
  if (pathname.startsWith('/stories')) return <StoriesPage />
  if (pathname.startsWith('/indexing')) return <IndexingPage />
  if (pathname.startsWith('/telegram')) return <TelegramPage />
  if (pathname.startsWith('/system')) return <SystemPage />
  if (pathname.startsWith('/admin') && role === 'ADMIN') return <AdminPage />
  return <LivePage />
}

function PageFallback() { return <div className="page page-fallback"><Skeleton /><Skeleton /><Skeleton /></div> }
